var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMvvm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#374850;}\r\n\t.st1{fill:#25B680;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.9,20c4,0,7.9,0,11.9,0l0,0C45,20,41,20,36.9,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.6,52.2c-1.8-1.6-3.3-3.3-4.9-4.9c-0.7-0.7-1.3-1.3-2.1-2c-0.2-0.2-0.2-0.3,0-0.5c2.3-2.3,4.6-4.6,6.9-6.9 h0.2V20.2c-0.2-0.3-0.3-0.2-0.5-0.2c-5.8,0-11.4,0-17.1,0c0,0,0,0,0,0.2c0,0-0.2,0-0.2,0.2c-2.5,2.5-4.8,4.8-7.3,7.3h11.5 c0,0.3-0.2,0.3-0.3,0.5c-3.5,3.5-6.9,6.9-10.4,10.6c-0.3,0.3-0.5,0.3-0.8,0c-5.9-5.9-11.9-11.9-18-18c-0.2-0.2-0.3-0.3-0.5-0.5l0,0 c-4,0-7.9,0-11.9,0c0,0.3,0.2,0.3,0.3,0.5c7.9,7.9,16,16,23.9,23.9c0.3,0.3,0.3,0.5,0,0.8C53.5,53.3,45.6,61.1,37.9,69 c-0.3,0.3-0.7,0.5-0.7,0.8h12c2-2.1,4.1-4.1,6.1-6.3c4.1-4.1,8.1-8.1,12.2-12.2c0.3-0.3,0.5-0.3,1,0c1.6,1.8,3.5,3.5,5.3,5.3 c1.5,1.3,2.8,2.8,4.3,4.3c0.5,0.3,0.8,0.8,1.3,1.2c-0.2,0.2-0.2,0.2-0.2,0.2c-3.6,0-7.3,0-10.9,0c-0.2,0-0.3,0-0.3,0.3 c1.6,1.5,3.3,3.1,4.8,4.8c0.8,0.8,1.6,1.5,2.5,2.5c5.8,0,11.5,0,17.3,0c0.3,0,0.5,0,0.5-0.5C92.6,63.7,92.6,58,92.6,52.2z M85,56 c-0.2,0-0.3-0.2-0.3-0.3c-1.6-1.5-3.1-3.1-4.8-4.6c-0.2-0.2-0.3-0.2-0.3-0.5c-0.2,0-0.2-0.2-0.3-0.2c-1.6-1.6-3.3-3.3-5.1-4.9 c-0.3-0.3-0.3-0.5,0-0.8c3.5-3.5,6.8-6.8,10.2-10.2c0.2-0.2,0.3-0.3,0.7-0.7v11.4C85,48.7,85,52.4,85,56L85,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.5,56.8c-0.2,0.2-0.5,0.5-0.7,0.7c-1.6,1.6-3.3,3.3-4.8,4.9c-0.2,0-0.3,0-0.3,0.3c-0.5,0.5-0.8,1-1.3,1.3 c-2,2-3.8,4-5.8,5.9H49.1c2-2.1,4.1-4.1,6.1-6.3c4.1-4.1,8.1-8.1,12.2-12.2c0.3-0.3,0.5-0.3,1,0C70,53.3,71.7,55,73.5,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85,33.9v11.4c-0.2,0-0.3,0.3-0.5,0.3c-1.6,1.6-3.3,3.3-4.9,4.9c-0.2,0-0.2-0.2-0.3-0.2 c-1.6-1.6-3.3-3.3-5.1-4.9c-0.3-0.3-0.3-0.5,0-0.8c3.5-3.5,6.8-6.8,10.2-10.2C84.7,34.2,84.9,34.1,85,33.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvvm);
export default __webpack_public_path__ + "static/media/MVVM.1b80e5f72e8e6b68db5eec7bfae673dd.svg";
export { ForwardRef as ReactComponent };